import { z } from "zod";
import { AgentId, AlbertineServiceAgentId, Email, VeryShortString } from "./primitives";

export const AgentRoleSchema = z.enum(["agent", "admin"]);
export type AgentRole = z.infer<typeof AgentRoleSchema>;

export const AgentDoc = z.object({
    name: z.string(),
    firstName: z.string(),
    permissionGroup: z.string().nullable().optional(),
    disabled: z.boolean().nullable(),
    createdAt: z.any(),
    email: Email,
    avatarFullPath: z.string().optional().nullable(),
    avatarThumbnailPath: z.string().optional().nullable(),
    slackId: VeryShortString.optional().nullable(),
    onboardingCallReservationUrl: z.url().nullable(),
    authProvider: z.literal("google").optional().nullable(),

    /**
     * @deprecated Permissions are now coming from the Postgres `permission_groups` table.
     */
    role: AgentRoleSchema,
});

export const Agent = z
    .object({ id: AgentId.or(AlbertineServiceAgentId) })
    .extend(AgentDoc.shape);

export type AgentDoc = z.infer<typeof AgentDoc>;
export type Agent = z.infer<typeof Agent>;

export const AgentUpdatables = AgentDoc.pick({
    avatarFullPath: true,
    avatarThumbnailPath: true,
    onboardingCallReservationUrl: true,
    slackId: true,
});

export type AgentUpdatables = z.infer<typeof AgentUpdatables>;

export function isAgentDoc(possibleAgent: unknown): possibleAgent is AgentDoc {
    return AgentDoc.safeParse(possibleAgent).success;
}

export const NewAgentPayload = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: Email,
    slackId: z.string().min(1),
    onboardingCallReservationUrl: z.url().min(1),
});

export type NewAgentPayload = z.infer<typeof NewAgentPayload>;
